import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../common/stores';
import { DocumentVisualStore } from '../../../documents/stores';
import { DocumentPreviewStore } from '../../stores';
import { IAppStoreBase, ISessionStoreBase } from '../../types';
import DocumentWithMinimap from '../../../documents/components/DocumentWithMinimap';

interface Props {
    appStore: IAppStoreBase;
    sessionStore: ISessionStoreBase;
    documentPreviewStore: DocumentPreviewStore;
    documentVisualStore: DocumentVisualStore;
    defaultScale?: number;
    minScale?: number;
    maxScale?: number;
    newPageNumberOffset?: number;
    minimapWidth?: number;
    minimapTopOffset?: number;
    showMinimap?: boolean;
    externalWindow?: Window;
    lightMode?: boolean;
    showPageNumbers?: boolean;
}

const DocumentViewer: React.FC<Props> = (props: Props) => {
    const {
        appStore,
        sessionStore,
        documentPreviewStore,
        documentVisualStore,
        defaultScale,
        minScale,
        maxScale,
        newPageNumberOffset,
        minimapWidth,
        minimapTopOffset,
        showMinimap,
        externalWindow,
        lightMode,
        showPageNumbers
    } = props;

    const { projectsStore } = useStore();

    return (
        <DocumentWithMinimap
            packageId={appStore.packageId}
            sessionId={appStore.sessionId}
            documentVisualStore={documentVisualStore}
            projectsStore={projectsStore}
            modelIsLoading={sessionStore.isLoading}
            defaultScale={defaultScale}
            minScale={minScale}
            maxScale={maxScale}
            minimapWidth={minimapWidth}
            minimapTopOffset={minimapTopOffset}
            newPageNumberOffset={newPageNumberOffset}
            targetWindow={externalWindow ?? window}
            showMinimap={showMinimap}
            fieldSearchMode={documentPreviewStore.searchInputVisible}
            lightMode={lightMode}
            showPageNumbers={showPageNumbers}
            usePageNumberInput
        />
    );
};

export default observer(DocumentViewer);
